// Generated by ReScript, PLEASE EDIT WITH CARE

import * as I18n from "../../primitives/I18n.res.js";
import * as Sheet from "../../primitives/Sheet.res.js";
import * as Future from "rescript-future/src/Future.res.js";
import * as Scalar from "../../core/Scalar.res.js";
import * as Belt_Array from "@rescript/runtime/lib/es6/Belt_Array.js";
import * as ApolloConfig from "../../core/ApolloConfig.res.js";
import * as FuturePromise from "rescript-future/src/FuturePromise.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Stdlib_Result from "@rescript/runtime/lib/es6/Stdlib_Result.js";
import * as Client from "@apollo/client";
import * as ApolloClient__React_Hooks_UseQuery from "rescript-apollo-client/src/@apollo/client/react/hooks/ApolloClient__React_Hooks_UseQuery.res.js";

let Raw = {};

let query = Client.gql(["query StockTransferSheetQuery($stockTransferId: ID!, $productsFirst: Int, $productsAfter: String)  {\nstockTransfer(id: $stockTransferId)  {\n__typename  \nid  \ncode  \nsenderShop  {\n__typename  \nname  \naddress  \ncity  \npostalCode  \ncountry  \nphoneNumber  \n}\n\nrecipientShop  {\n__typename  \nname  \naddress  \ncity  \npostalCode  \ncountry  \nphoneNumber  \n}\n\ncreatedAt  \nproducts(first: $productsFirst, after: $productsAfter)  {\n__typename  \ntotalCount  \npageInfo  {\n__typename  \nendCursor  \nhasNextPage  \n}\n\nedges  {\n__typename  \nnode  {\n__typename  \nrecipientVariant  {\n__typename  \nformattedName  \nformattedDescription  \nstockKeepingUnit  \n}\n\nquantity  \n}\n\n}\n\n}\n\n}\n\n}\n"]);

function parse(value) {
  let value$1 = value.stockTransfer;
  let tmp;
  if (value$1 == null) {
    tmp = undefined;
  } else {
    let value$2 = value$1.senderShop;
    let value$3 = value$2.phoneNumber;
    let value$4 = value$1.recipientShop;
    let value$5 = value$4.phoneNumber;
    let value$6 = value$1.products;
    let value$7 = value$6.pageInfo;
    let value$8 = value$7.endCursor;
    let value$9 = value$7.hasNextPage;
    let value$10 = value$6.edges;
    tmp = {
      __typename: value$1.__typename,
      id: value$1.id,
      code: value$1.code,
      senderShop: {
        __typename: value$2.__typename,
        name: value$2.name,
        address: value$2.address,
        city: value$2.city,
        postalCode: value$2.postalCode,
        country: value$2.country,
        phoneNumber: !(value$3 == null) ? value$3 : undefined
      },
      recipientShop: {
        __typename: value$4.__typename,
        name: value$4.name,
        address: value$4.address,
        city: value$4.city,
        postalCode: value$4.postalCode,
        country: value$4.country,
        phoneNumber: !(value$5 == null) ? value$5 : undefined
      },
      createdAt: Scalar.Datetime.parse(value$1.createdAt),
      products: {
        __typename: value$6.__typename,
        totalCount: value$6.totalCount,
        pageInfo: {
          __typename: value$7.__typename,
          endCursor: !(value$8 == null) ? value$8 : undefined,
          hasNextPage: !(value$9 == null) ? value$9 : undefined
        },
        edges: value$10.map(value => {
          let value$1 = value.node;
          let value$2 = value$1.recipientVariant;
          let value$3 = value$2.stockKeepingUnit;
          return {
            __typename: value.__typename,
            node: {
              __typename: value$1.__typename,
              recipientVariant: {
                __typename: value$2.__typename,
                formattedName: value$2.formattedName,
                formattedDescription: value$2.formattedDescription,
                stockKeepingUnit: !(value$3 == null) ? value$3 : undefined
              },
              quantity: value$1.quantity
            }
          };
        })
      }
    };
  }
  return {
    stockTransfer: tmp
  };
}

function serialize(value) {
  let value$1 = value.stockTransfer;
  let stockTransfer;
  if (value$1 !== undefined) {
    let value$2 = value$1.products;
    let value$3 = value$2.edges;
    let edges = value$3.map(value => {
      let value$1 = value.node;
      let value$2 = value$1.quantity;
      let value$3 = value$1.recipientVariant;
      let value$4 = value$3.stockKeepingUnit;
      let stockKeepingUnit = value$4 !== undefined ? value$4 : null;
      let value$5 = value$3.formattedDescription;
      let value$6 = value$3.formattedName;
      let value$7 = value$3.__typename;
      let recipientVariant = {
        __typename: value$7,
        formattedName: value$6,
        formattedDescription: value$5,
        stockKeepingUnit: stockKeepingUnit
      };
      let value$8 = value$1.__typename;
      let node = {
        __typename: value$8,
        recipientVariant: recipientVariant,
        quantity: value$2
      };
      let value$9 = value.__typename;
      return {
        __typename: value$9,
        node: node
      };
    });
    let value$4 = value$2.pageInfo;
    let value$5 = value$4.hasNextPage;
    let hasNextPage = value$5 !== undefined ? value$5 : null;
    let value$6 = value$4.endCursor;
    let endCursor = value$6 !== undefined ? value$6 : null;
    let value$7 = value$4.__typename;
    let pageInfo = {
      __typename: value$7,
      endCursor: endCursor,
      hasNextPage: hasNextPage
    };
    let value$8 = value$2.totalCount;
    let value$9 = value$2.__typename;
    let products = {
      __typename: value$9,
      totalCount: value$8,
      pageInfo: pageInfo,
      edges: edges
    };
    let value$10 = value$1.createdAt;
    let value$11 = Scalar.Datetime.serialize(value$10);
    let value$12 = value$1.recipientShop;
    let value$13 = value$12.phoneNumber;
    let phoneNumber = value$13 !== undefined ? value$13 : null;
    let value$14 = value$12.country;
    let value$15 = value$12.postalCode;
    let value$16 = value$12.city;
    let value$17 = value$12.address;
    let value$18 = value$12.name;
    let value$19 = value$12.__typename;
    let recipientShop = {
      __typename: value$19,
      name: value$18,
      address: value$17,
      city: value$16,
      postalCode: value$15,
      country: value$14,
      phoneNumber: phoneNumber
    };
    let value$20 = value$1.senderShop;
    let value$21 = value$20.phoneNumber;
    let phoneNumber$1 = value$21 !== undefined ? value$21 : null;
    let value$22 = value$20.country;
    let value$23 = value$20.postalCode;
    let value$24 = value$20.city;
    let value$25 = value$20.address;
    let value$26 = value$20.name;
    let value$27 = value$20.__typename;
    let senderShop = {
      __typename: value$27,
      name: value$26,
      address: value$25,
      city: value$24,
      postalCode: value$23,
      country: value$22,
      phoneNumber: phoneNumber$1
    };
    let value$28 = value$1.code;
    let value$29 = value$1.id;
    let value$30 = value$1.__typename;
    stockTransfer = {
      __typename: value$30,
      id: value$29,
      code: value$28,
      senderShop: senderShop,
      recipientShop: recipientShop,
      createdAt: value$11,
      products: products
    };
  } else {
    stockTransfer = null;
  }
  return {
    stockTransfer: stockTransfer
  };
}

function serializeVariables(inp) {
  let a = inp.productsFirst;
  let a$1 = inp.productsAfter;
  return {
    stockTransferId: inp.stockTransferId,
    productsFirst: a !== undefined ? a : undefined,
    productsAfter: a$1 !== undefined ? a$1 : undefined
  };
}

function makeVariables(stockTransferId, productsFirst, productsAfter, param) {
  return {
    stockTransferId: stockTransferId,
    productsFirst: productsFirst,
    productsAfter: productsAfter
  };
}

let Query_inner = {
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  makeVariables: makeVariables
};

let include = ApolloClient__React_Hooks_UseQuery.Extend({
  query: query,
  Raw: Raw,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables
});

let Query_refetchQueryDescription = include.refetchQueryDescription;

let Query_use = include.use;

let Query_useLazy = include.useLazy;

let Query_useLazyWithVariables = include.useLazyWithVariables;

let Query = {
  Query_inner: Query_inner,
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  makeVariables: makeVariables,
  refetchQueryDescription: Query_refetchQueryDescription,
  use: Query_use,
  useLazy: Query_useLazy,
  useLazyWithVariables: Query_useLazyWithVariables
};

function makeFilename(code, extension) {
  return I18n.t("transferorder") + "_" + code + "." + extension;
}

function makeCsvFilename(code) {
  return makeFilename(code, Sheet.csvFileExtension);
}

function makeExcelFilename(code) {
  return makeFilename(code, Sheet.excelFileExtension);
}

function makeRows(stockTransfer) {
  let titleRow = [
    I18n.t("Transfer of") + " " + I18n.dateTimeFormat(undefined, "short", undefined, undefined, undefined, undefined, undefined, undefined, undefined, stockTransfer.createdAt) + " " + I18n.t("at") + " " + I18n.dateTimeFormat(undefined, undefined, "short", undefined, undefined, undefined, undefined, undefined, undefined, stockTransfer.createdAt),
    I18n.template(I18n.t("Reference{{entilted}}{{code}}"), {
      entilted: " : ",
      code: stockTransfer.code
    }, undefined)
  ];
  let headers = [
    I18n.t("Sender") + " :",
    I18n.t("Recipient") + " :"
  ];
  let shopNameRows = [
    stockTransfer.senderShop.name,
    stockTransfer.recipientShop.name
  ];
  let shopAdressRows = [
    stockTransfer.senderShop.address + " " + stockTransfer.senderShop.postalCode + " " + stockTransfer.senderShop.city + ", " + stockTransfer.senderShop.country,
    stockTransfer.recipientShop.address + " " + stockTransfer.recipientShop.postalCode + " " + stockTransfer.recipientShop.city + ", " + stockTransfer.recipientShop.country
  ];
  let shopPhoneNumberRows = [
    Stdlib_Option.getOr(stockTransfer.senderShop.phoneNumber, ""),
    Stdlib_Option.getOr(stockTransfer.recipientShop.phoneNumber, "")
  ];
  let productHeaderRows = [
    "SKU",
    I18n.t("Product's name"),
    "Description",
    I18n.t("Transferred quantity")
  ];
  let productsRows = stockTransfer.products.edges.map(product => [
    Stdlib_Option.getOr(product.node.recipientVariant.stockKeepingUnit, ""),
    product.node.recipientVariant.formattedName,
    product.node.recipientVariant.formattedDescription,
    product.node.quantity.toString()
  ]);
  return Belt_Array.concatMany([
    [
      titleRow,
      [],
      headers,
      shopNameRows,
      shopAdressRows,
      shopPhoneNumberRows,
      [],
      productHeaderRows
    ],
    productsRows.map(row => row)
  ]);
}

function makeCsvPlainText(stockTransfer) {
  return Sheet.makeCsvPlainText(undefined, makeRows(stockTransfer));
}

function makeCsvBlob(stockTransfer) {
  return Stdlib_Result.map(Sheet.makeCsvPlainText(undefined, makeRows(stockTransfer)), Sheet.makeCsvBlobFromPlainText);
}

function query$1(stockTransferId, productsFirst, productsAfter) {
  return FuturePromise.fromPromise(ApolloConfig.makeClient().rescript_query({
    query: query,
    Raw: Raw,
    parse: parse,
    serialize: serialize,
    serializeVariables: serializeVariables
  }, undefined, undefined, undefined, undefined, {
    stockTransferId: stockTransferId,
    productsFirst: productsFirst,
    productsAfter: productsAfter
  }));
}

function queryWithAllProducts(stockTransferId, previousResult, productEdgesEndCursor, productEdgesPerFetchOpt, param) {
  let productEdgesPerFetch = productEdgesPerFetchOpt !== undefined ? productEdgesPerFetchOpt : ApolloConfig.edgesPerFetchLimit;
  return Future.flatMap(query$1(stockTransferId, productEdgesPerFetch, productEdgesEndCursor), undefined, result => {
    if (result.TAG !== "Ok") {
      return Future.value({
        TAG: "Error",
        _0: "QueryFailure"
      });
    }
    let match = result._0;
    if (match.TAG !== "Ok") {
      return Future.value({
        TAG: "Error",
        _0: "QueryFailure"
      });
    }
    let match$1 = match._0;
    let stockTransfer = match$1.data.stockTransfer;
    if (stockTransfer === undefined) {
      if (match$1.error !== undefined) {
        return Future.value({
          TAG: "Error",
          _0: "QueryFailure"
        });
      } else {
        return Future.value({
          TAG: "Ok",
          _0: undefined
        });
      }
    }
    if (match$1.error !== undefined) {
      return Future.value({
        TAG: "Error",
        _0: "QueryFailure"
      });
    }
    let stockTransfer$1;
    if (previousResult !== undefined) {
      let init = stockTransfer.products;
      stockTransfer$1 = {
        __typename: stockTransfer.__typename,
        id: stockTransfer.id,
        code: stockTransfer.code,
        senderShop: stockTransfer.senderShop,
        recipientShop: stockTransfer.recipientShop,
        createdAt: stockTransfer.createdAt,
        products: {
          __typename: init.__typename,
          totalCount: init.totalCount,
          pageInfo: init.pageInfo,
          edges: previousResult.products.edges.concat(stockTransfer.products.edges)
        }
      };
    } else {
      stockTransfer$1 = stockTransfer;
    }
    let match$2 = stockTransfer$1.products.pageInfo;
    let match$3 = match$2.hasNextPage;
    if (match$3 !== undefined && match$3) {
      return queryWithAllProducts(stockTransferId, stockTransfer$1, match$2.endCursor, productEdgesPerFetch, undefined);
    } else {
      return Future.value({
        TAG: "Ok",
        _0: stockTransfer$1
      });
    }
  });
}

function queryAndMakeCsvBlob(stockTransferId) {
  return Future.map(queryWithAllProducts(stockTransferId, undefined, undefined, undefined, undefined), undefined, results => {
    if (results.TAG !== "Ok") {
      return {
        TAG: "Error",
        _0: results._0
      };
    }
    let stockTransfer = results._0;
    if (stockTransfer === undefined) {
      return {
        TAG: "Error",
        _0: "NoDataFailure"
      };
    }
    let csvBlob = Stdlib_Result.map(Sheet.makeCsvPlainText(undefined, makeRows(stockTransfer)), Sheet.makeCsvBlobFromPlainText);
    if (csvBlob.TAG === "Ok") {
      return {
        TAG: "Ok",
        _0: csvBlob._0
      };
    } else {
      return {
        TAG: "Error",
        _0: "WriteBlobFailure"
      };
    }
  });
}

function makeExcelBlob(stockTransfer) {
  return Future.mapError(Sheet.makeExcelBlob(makeRows(stockTransfer), I18n.t("Stock transfer")), undefined, () => "WriteBlobFailure");
}

function queryAndMakeExcelBlob(stockTransferId) {
  return Future.flatMap(queryWithAllProducts(stockTransferId, undefined, undefined, undefined, undefined), undefined, results => {
    if (results.TAG !== "Ok") {
      return Future.value({
        TAG: "Error",
        _0: results._0
      });
    }
    let stockTransfer = results._0;
    if (stockTransfer !== undefined) {
      return makeExcelBlob(stockTransfer);
    } else {
      return Future.value({
        TAG: "Error",
        _0: "NoDataFailure"
      });
    }
  });
}

export {
  Query,
  makeFilename,
  makeCsvFilename,
  makeExcelFilename,
  makeRows,
  makeCsvPlainText,
  makeCsvBlob,
  query$1 as query,
  queryWithAllProducts,
  queryAndMakeCsvBlob,
  makeExcelBlob,
  queryAndMakeExcelBlob,
}
/* query Not a pure module */
